module.exports = __webpack_public_path__ + "static/media/perso1.82e12dd3.webp";